import React from 'react';
import {
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
} from 'react-flow-renderer';

import './edgeStyle.css';

export default function LabelEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId,
}) {
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}/>
       <foreignObject
        width={data.width}
        height={data.height}
        x={edgeCenterX - data.width / 2}
        y={edgeCenterY - data.height / 2}
        className="react-flow__edge-text"
        requiredExtensions="http://www.w3.org/1999/xhtml"> 
        <body className="react-flow__edge-text edge-label" >
          {data.label}
        </body>
      </foreignObject>
    </>
  );
}